import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface ProgressBarValue {
  value: number;
}

function ProgressBar({ value }: ProgressBarValue) {
  const { i18n } = useTranslation();
  const [progress, setProgress] = useState<boolean>(false);

  useEffect(() => {
    setProgress(true);
  }, []);

  return (
    <div className="relative w-full h-[20px] bg-[#c8ccc5] rounded-br-[15px] rounded-tl-[15px] rounded-bl-[15px] rounded-tr-[15px]">
      <div
        className="h-full transition-all duration-[4s] rounded-br-[15px] rounded-tl-[15px] rounded-bl-[15px] rounded-tr-[15px] bg-first_color"
        style={{
          width: `${!progress ? 0 : value.toString()}%`,
        }}
      ></div>
      <div
        className={`absolute top-[10%] right-[50%] text-second_color font-${
          i18n.language === "en" ? "Poppins" : "Almarai"
        } font-[600] text-[13px]`}
      >
        {value}%
      </div>
    </div>
  );
}

export default ProgressBar;
